var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 155,
    viewBox: "0 0 273 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.539 103.778C159.539 100.948 158.639 98.1984 156.979 95.9184L148.629 84.4484C145.869 80.6484 141.449 78.3984 136.749 78.3984H113.599C107.399 78.3984 102.379 83.4184 102.379 89.6184V133.138C102.379 139.338 107.399 144.358 113.599 144.358H143.349C143.349 139.808 145.349 135.208 148.439 132.348C151.229 129.778 155.429 128.168 159.519 128.168V103.768L159.539 103.778Z",
    stroke: "#2866A9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.469 102.359H142.459",
    stroke: "#DA1C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.738 102.359V120.669C140.738 123.359 138.558 125.529 135.878 125.529H126.048C123.358 125.529 121.188 123.349 121.188 120.669V102.359",
    stroke: "#DA1C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.18 119.542V108.172",
    stroke: "#DA1C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.758 108.172V119.542",
    stroke: "#DA1C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.947 102.36V98.8805C134.947 97.9705 134.208 97.2305 133.298 97.2305H128.587C127.677 97.2305 126.938 97.9705 126.938 98.8805V102.36",
    stroke: "#DA1C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.119 132.711C153.099 132.711 148.219 137.591 148.219 143.611C148.219 149.631 153.099 154.511 159.119 154.511C165.139 154.511 170.019 149.631 170.019 143.611C170.019 137.591 165.139 132.711 159.119 132.711ZM160.059 149.601C159.989 149.761 159.899 149.891 159.789 150.001C159.679 150.111 159.539 150.201 159.379 150.271C159.219 150.331 159.049 150.371 158.879 150.371C158.709 150.371 158.529 150.341 158.369 150.271C158.209 150.201 158.069 150.121 157.959 150.001C157.849 149.881 157.749 149.751 157.689 149.601C157.619 149.441 157.589 149.281 157.589 149.091C157.589 148.901 157.619 148.751 157.689 148.591C157.759 148.431 157.849 148.301 157.959 148.181C158.069 148.061 158.209 147.981 158.369 147.911C158.529 147.841 158.699 147.811 158.879 147.811C159.059 147.811 159.219 147.841 159.379 147.911C159.539 147.981 159.669 148.071 159.789 148.181C159.909 148.291 159.989 148.431 160.059 148.591C160.129 148.751 160.159 148.921 160.159 149.091C160.159 149.261 160.129 149.441 160.059 149.601ZM162.349 141.841C162.229 142.151 162.069 142.431 161.879 142.661C161.689 142.891 161.489 143.091 161.259 143.261C161.039 143.431 160.829 143.591 160.629 143.741C160.429 143.891 160.259 144.041 160.119 144.181C159.979 144.321 159.889 144.491 159.859 144.671L159.659 145.911H158.219L158.079 144.521C158.079 144.521 158.079 144.471 158.079 144.451V144.381C158.079 144.131 158.139 143.911 158.269 143.731C158.389 143.551 158.549 143.371 158.739 143.211C158.929 143.051 159.129 142.891 159.339 142.741C159.559 142.591 159.759 142.421 159.939 142.241C160.129 142.061 160.279 141.861 160.409 141.631C160.539 141.401 160.599 141.141 160.599 140.831C160.599 140.631 160.559 140.441 160.479 140.281C160.399 140.121 160.299 139.981 160.159 139.861C160.019 139.741 159.859 139.651 159.669 139.591C159.479 139.531 159.269 139.501 159.049 139.501C158.729 139.501 158.449 139.541 158.229 139.611C158.009 139.681 157.819 139.761 157.659 139.851C157.499 139.941 157.369 140.021 157.259 140.091C157.149 140.161 157.059 140.201 156.969 140.201C156.769 140.201 156.619 140.121 156.529 139.951L155.979 139.071C156.169 138.901 156.379 138.741 156.609 138.591C156.839 138.441 157.089 138.301 157.349 138.191C157.609 138.081 157.909 137.991 158.219 137.921C158.529 137.851 158.869 137.821 159.229 137.821C159.719 137.821 160.169 137.891 160.579 138.021C160.989 138.161 161.329 138.351 161.619 138.601C161.909 138.851 162.129 139.161 162.289 139.511C162.449 139.871 162.529 140.271 162.529 140.711C162.529 141.151 162.469 141.511 162.339 141.831L162.349 141.841Z",
    fill: "#DA1C4E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9297 97.1484H40.7497",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26 90.8881C6.26 92.6281 7.67 94.0481 9.42 94.0481C10.26 94.0481 11.02 93.7181 11.59 93.1881C12.2 92.6081 12.58 91.7981 12.58 90.8881V90.8681C12.58 87.3981 9.76 84.5781 6.29 84.5781C2.82 84.5781 0 87.3981 0 90.8681C0 94.3381 2.82 97.1581 6.29 97.1581H22.27",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.42 13.8789L0 13.9889",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0816 7.31V7.29C38.0816 3.82 40.9016 1 44.3716 1C47.8416 1 50.6616 3.82 50.6616 7.29C50.6616 10.76 47.8416 13.58 44.3716 13.58L20.1016 13.8",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M242.568 125.651C242.568 128.001 244.468 129.901 246.818 129.901C247.948 129.901 248.968 129.461 249.738 128.741C250.558 127.961 251.078 126.861 251.078 125.641V125.611C251.078 120.931 247.288 117.141 242.608 117.141C237.928 117.141 234.138 120.931 234.138 125.611C234.138 130.291 237.928 134.081 242.608 134.081H225.648",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M222.08 37.9688H211.09",
    stroke: "#DEE4FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M272.301 19.21C271.251 15.07 267.501 12 263.041 12C260.111 12 257.481 13.32 255.721 15.4C254.311 17.07 253.471 19.22 253.471 21.57C253.471 21.77 253.491 21.97 253.501 22.17C252.551 21.78 251.511 21.57 250.421 21.57C245.891 21.57 242.221 25.24 242.221 29.77C242.221 34.3 245.891 37.97 250.421 37.97H230.781",
    stroke: "#DEE4FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1506 53.6997C48.2607 53.6997 49.1606 52.7998 49.1606 51.6897C49.1606 50.5796 48.2607 49.6797 47.1506 49.6797C46.0405 49.6797 45.1406 50.5796 45.1406 51.6897C45.1406 52.7998 46.0405 53.6997 47.1506 53.6997Z",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M234.481 90.5273H231.371",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M232.93 92.0788V88.9688",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6217 137.973H65.5117",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0703 139.532V136.422",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0403 56.7383H37.8203",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9297 59.8489V53.6289",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M232.931 96.2891H226.711",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M229.82 99.3997V93.1797",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d76881d582ade14cc3238dc52d085329.svg";
export { ForwardRef as ReactComponent };